import { unsafeCSS } from 'lit';
import { lightColorTokenGotoResolve, darkColorTokenGotoResolve } from '@getgo/chameleon-core';
import constantSynapseColors from './constant-colors.js';
export const lightSynapseColors = `
  /**
   *
   * Legacy Synapse colors assigned with the new GoTo colors.
   * These are defined for LIGHT THEME.
   *
   * */
  --synapse-color-neutral-1: var(--synapse-color-white);
  --synapse-color-neutral-2: var(--synapse-color-almost-white);
  --synapse-color-neutral-3: var(--synapse-color-grey-lighter);
  --synapse-color-neutral-4: var(--synapse-color-grey-light);
  --synapse-color-neutral-5: var(--synapse-color-grey-middle);
  --synapse-color-neutral-6: var(--synapse-color-grey-dark);
  --synapse-color-neutral-7: var(--synapse-color-grey-darker);
  --synapse-color-neutral-8: var(--synapse-color-almost-black);
  --synapse-color-neutral-9: var(--synapse-color-black);

  --synapse-color-primary-1: var(--synapse-color-primary-lighter);
  --synapse-color-primary-2: var(--synapse-color-primary-light);
  --synapse-color-primary-3: var(--synapse-color-primary-middle);
  --synapse-color-primary-4: var(--synapse-color-primary-dark);
  --synapse-color-primary-5: var(--synapse-color-primary-darker);

  --synapse-frame-color: var(--neutral-000);
  --synapse-panel-color: var(--neutral-000);
  --synapse-text-color: var(--neutral-900);

  --synapse-brand-main: var(--neutral-900);
  --synapse-brand-sub: #9254FF;
  --synapse-modal-background-color: rgba(0, 0, 0, 0.5);

  --brand-100: rgba(235, 222, 255, 1);
  --brand-200: rgba(218, 196, 255, 1);
  --brand-300: rgba(194, 164, 255, 1);
  --brand-400: rgba(163, 123, 251, 1);
  --brand-500: rgba(133, 82, 246, 1);
  --brand-600: rgba(95, 54, 211, 1);
  --brand-700: rgba(50, 28, 156, 1);
`;
export const darkSynapseColors = `
  /**
   *
   * Legacy Synapse colors assigned with the new GoTo colors.
   * These are defined for DARK THEME.
   *
   * */
  --synapse-color-neutral-9: var(--synapse-color-white);
  --synapse-color-neutral-8: var(--synapse-color-almost-white);
  --synapse-color-neutral-7: var(--synapse-color-grey-lighter);
  --synapse-color-neutral-6: var(--synapse-color-grey-light);
  --synapse-color-neutral-5: var(--synapse-color-grey-middle);
  --synapse-color-neutral-4: var(--synapse-color-grey-dark);
  --synapse-color-neutral-3: var(--synapse-color-grey-darker);
  --synapse-color-neutral-2: var(--synapse-color-almost-black);
  --synapse-color-neutral-1: var(--synapse-color-black);

  --synapse-color-primary-1: var(--synapse-color-dark-darker);
  --synapse-color-primary-2: var(--synapse-color-dark-dark);
  --synapse-color-primary-3: var(--synapse-color-dark-middle);
  --synapse-color-primary-4: var(--synapse-color-dark-light);
  --synapse-color-primary-5: var(--synapse-color-dark-lighter);

  --synapse-frame-color: var(--neutral-900);
  --synapse-panel-color: var(--neutral-900);
  --synapse-text-color: var(--neutral-000);

  --synapse-brand-main: var(--neutral-000);
  --synapse-brand-sub: var(--purple-300);
  --synapse-modal-background-color: rgba(255, 255, 255, 0.5);

  --brand-100: rgba(235, 222, 255, 1);
  --brand-200: rgba(218, 196, 255, 1);
  --brand-300: rgba(194, 164, 255, 1);
  --brand-400: rgba(163, 123, 251, 1);
  --brand-500: rgba(133, 82, 246, 1);
  --brand-600: rgba(95, 54, 211, 1);
  --brand-700: rgba(50, 28, 156, 1);
`;
export const darkGoToColors = Object.entries(darkColorTokenGotoResolve)
    .map(([key, value]) => `--${key}: ${value};`)
    .join('\n');
export const lightGoToColors = Object.entries(lightColorTokenGotoResolve)
    .map(([key, value]) => `--${key}: ${value};`)
    .join('\n');
export const lightTheme = `
    ${lightSynapseColors}
    ${lightGoToColors}
  `;
export const darkTheme = `
    ${darkSynapseColors}
    ${darkGoToColors}
  `;
export const rawCss = `
  :host([theme^='synapse-']){
    ${constantSynapseColors}
  }

  :host([theme='synapse-light']) {
    ${lightTheme}
  }

  :host([theme='synapse-dark']) {
    ${darkTheme}
  }
`;
export default unsafeCSS(rawCss);
